import React from 'react'
import {NavLink} from "react-router-dom"


/**
 *  Навигация сайта
 *
 *  @param {NavItem[]} links
 *  @returns {JSX.Element}
 *  @constructor
 */
export default function Nav({ links }){

    const items = links.map((link, index) => {
        // Разделитель
        if(link.to==='|'){
            return ( <li key={index} className='separator'></li> )
        }
        // Меню
        return (
            <li key={index}>
                <NavLink to={link.to} title={link.title} dangerouslySetInnerHTML={{ __html: link.label }} />
            </li>
        )
    })

    // Вывод меню
    return ( <nav><ul>{ items }</ul></nav> )
}


